import React, { useContext } from "react";
import { RouteComponentProps, Prompt } from "react-router-dom";
import { Site as ISite } from "../../../types/apiResponses";
import Text from "../../../style-guide/Text/Text";
import Form from "../../../style-guide/Inputs/Form";
import Fader from "../../../style-guide/Fader/Fader";
import Block from "../../../style-guide/Block/Block";
import usePublisher from "../../../hooks/usePublisher";
import Section from "../../../style-guide/Section/Section";
import ActionBar from "../../../components/ActionBar/ActionBar";
import Card from "../../../style-guide/Card/Card";
import createPublisherInputField from "../../../util/createPublisherInputField";
import Crumb from "../../../components/Crumb/Crumb";
import { UserContext } from "../../../context/User";
import { LEAVE_PAGE_MESSAGE } from "../../../constants/general";
import { RevisionType } from "../../../constants/api";
import { SiteContext } from "../../../context/Site";

interface Props extends RouteComponentProps<{}> {}

const Catalogs: React.FC<Props> = () => {
  const user = useContext(UserContext).data;
  const siteContext = useContext(SiteContext);

  const publisher = usePublisher<ISite>({
    id: user.site!,
    baseUrl: ["site"],
    baseDashboardUrl: "/innstillinger/kataloger",
    initialData: {},
    skipId: true,
    onSubmit: (site: ISite) => {
      if (site) {
        siteContext.setData(site);
      }
    }
  });

  return (
    <Form onSubmit={publisher.form.submit}>
      <Prompt
        when={publisher.form.hasMadeChanges}
        message={() => LEAVE_PAGE_MESSAGE}
      />
      <Fader>
        <Block hugTop hugBottom>
          <Text element="h1" variant="display3" gutterBottom>
            <Crumb url="/innstillinger">Innstillinger</Crumb>
            Kataloger
          </Text>
        </Block>
        <Section>
          <Card>
            <Block>
              <Section hugTop>
                <Text element="h2" variant="title">
                  Generelt
                </Text>
              </Section>
              {createPublisherInputField(publisher, {
                path: "catalogRuleRestrictPricingUpperBound",
                label: "catalogRuleRestrictPricingUpperBound",
                type: "boolean"
              })}
              {createPublisherInputField(publisher, {
                path: "catalogRuleRestrictPricingLowerBound",
                label: "catalogRuleRestrictPricingLowerBound",
                type: "boolean"
              })}
              {createPublisherInputField(publisher, {
                path: "productCatalogAllowAdding",
                label: "productCatalogAllowAdding",
                type: "boolean"
              })}
              {createPublisherInputField(publisher, {
                path: "productCatalogAllowRemoving",
                label: "productCatalogAllowRemoving",
                type: "boolean"
              })}
            </Block>
          </Card>
        </Section>
      </Fader>
      <ActionBar
        publisher={publisher}
        revisions
        revisionType={RevisionType.Site}
        revisionReference={publisher.form.data._id}
      />
    </Form>
  );
};

export default Catalogs;
